module.exports = __webpack_public_path__ + "img/nz.4ba005aa.png";